/**
 * Gestoria Moreno - v1.0.0
 * Botón flotante de llamada rápida (visible solo en móvil)
 */

import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";

function FloatingCallButton() {
  return (
    <MKBox
      component="a"
      href="tel:+34958805110"
      aria-label="Llamar a Gestoría Moreno"
      sx={{
        display: { xs: "flex", md: "none" },
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 9998,
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#25D366",
        color: "white",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        textDecoration: "none",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "scale(1.1)",
          boxShadow: "0 6px 16px rgba(0,0,0,0.4)",
        },
      }}
    >
      <Icon sx={{ fontSize: "28px !important", color: "white !important" }}>phone</Icon>
    </MKBox>
  );
}

export default FloatingCallButton;
